"use strict";

var ProductId = /* @__PURE__ */(ProductId2 => {
  ProductId2["DoorHub"] = "doorHub";
  ProductId2["DoorHubMini"] = "doorHubMini";
  ProductId2["G2ReaderPro"] = "g2ReaderPro";
  ProductId2["G2Reader"] = "g2Reader";
  ProductId2["G3Reader"] = "g3Reader";
  ProductId2["G3TouchWall"] = "g3TouchWall";
  ProductId2["G3TouchEnterprise"] = "g3TouchEnterprise";
  ProductId2["G3TouchPro"] = "g3TouchPro";
  ProductId2["G3ReaderPro"] = "g3ReaderPro";
  ProductId2["G3ReaderFlex"] = "g3ReaderFlex";
  ProductId2["G3StarterKit"] = "g3StarterKit";
  ProductId2["G3StarterKitPro"] = "g3StarterKitPro";
  ProductId2["ReaderLite"] = "readerLite";
  ProductId2["_8PoEGen1"] = "_8PoEGen1";
  ProductId2["_8PoESFPGen1"] = "_8PoESFPGen1";
  ProductId2["AccessHub"] = "accessHub";
  ProductId2["UaUltra"] = "uaUltra";
  ProductId2["AcInWall"] = "acInWall";
  ProductId2["AcMesh"] = "acMesh";
  ProductId2["AcMeshProfessional"] = "acMeshProfessional";
  ProductId2["Aggregation"] = "aggregation";
  ProductId2["Ai360"] = "ai360";
  ProductId2["AiBullet"] = "aiBullet";
  ProductId2["AiDSLR"] = "aiDSLR";
  ProductId2["AiPro"] = "aiPro";
  ProductId2["AiTurret"] = "aiTurret";
  ProductId2["AiDome"] = "aiDome";
  ProductId2["AiLpr"] = "aiLpr";
  ProductId2["BuildingBridge"] = "buildingBridge";
  ProductId2["BuildingBridgeXG"] = "buildingBridgeXG";
  ProductId2["BaseStationXG"] = "baseStationXG";
  ProductId2["ConnectDisplay"] = "connectDisplay";
  ProductId2["CloudKeyEnterprise"] = "cloudKeyEnterprise";
  ProductId2["CloudKeyG2Plus"] = "cloudKeyG2Plus";
  ProductId2["ElevatorHub"] = "elevatorHub";
  ProductId2["Efg"] = "efg";
  ProductId2["Enterprise8PoE"] = "enterprise8PoE";
  ProductId2["Enterprise24PoE"] = "enterprise24PoE";
  ProductId2["Enterprise48PoE"] = "enterprise48PoE";
  ProductId2["EnterpriseAccessHub"] = "enterpriseAccessHub";
  ProductId2["EnterpriseXG24"] = "enterpriseXG24";
  ProductId2["E7"] = "e7";
  ProductId2["E7Campus"] = "e7Campus";
  ProductId2["E7Audience"] = "e7Audience";
  ProductId2["Fiber"] = "fiber";
  ProductId2["EvStationPro"] = "evStationPro";
  ProductId2["EvStationLite"] = "evStationLite";
  ProductId2["Flex"] = "flex";
  ProductId2["Flex2_5G"] = "flex2_5G";
  ProductId2["Flex2_5GPoE"] = "flex2_5GPoE";
  ProductId2["Flex10GbE"] = "flex10GbE";
  ProductId2["FlexMini"] = "flexMini";
  ProductId2["FlexMini2_5G"] = "flexMini2_5G";
  ProductId2["GatewayLite"] = "gatewayLite";
  ProductId2["GatewayProfessional"] = "gatewayProfessional";
  ProductId2["GatewayEnterprise"] = "gatewayEnterprise";
  ProductId2["GatewayMax"] = "gatewayMax";
  ProductId2["G4Instant"] = "g4Instant";
  ProductId2["Gpon"] = "gpon";
  ProductId2["G4PTZ"] = "g4PTZ";
  ProductId2["G5PTZ"] = "g5PTZ";
  ProductId2["G5Bullet"] = "g5Bullet";
  ProductId2["G5Dome"] = "g5Dome";
  ProductId2["G5Flex"] = "g5Flex";
  ProductId2["G5Pro"] = "g5Pro";
  ProductId2["G5DomeUltra"] = "g5DomeUltra";
  ProductId2["G5TurretUltra"] = "g5TurretUltra";
  ProductId2["HiCapacityAggregation"] = "hiCapacityAggregation";
  ProductId2["Industrial"] = "industrial";
  ProductId2["Intercom"] = "intercom";
  ProductId2["Lite8POE"] = "lite8PoE";
  ProductId2["Lite16POE"] = "lite16PoE";
  ProductId2["LteBackup"] = "lteBackup";
  ProductId2["LteBackupProfessional"] = "lteBackupProfessional";
  ProductId2["MissionCritical"] = "missionCritical";
  ProductId2["Nvr"] = "nvr";
  ProductId2["NvrPro"] = "nvrPro";
  ProductId2["NvrInstant"] = "nvrInstant";
  ProductId2["Envr"] = "envr";
  ProductId2["OfficialUniFiHosting"] = "officialUniFiHosting";
  ProductId2["PhoneTouch"] = "phoneTouch";
  ProductId2["PhoneTouchMax"] = "phoneTouchMax";
  ProductId2["Professional8PoE"] = "professional8PoE";
  ProductId2["Professional24"] = "professional24";
  ProductId2["Professional24PoE"] = "professional24PoE";
  ProductId2["Professional48"] = "professional48";
  ProductId2["Professional48PoE"] = "professional48PoE";
  ProductId2["ProfessionalMax16"] = "professionalMax16";
  ProductId2["ProfessionalMax24"] = "professionalMax24";
  ProductId2["ProfessionalMax48"] = "professionalMax48";
  ProductId2["ProfessionalMax16PoE"] = "professionalMax16PoE";
  ProductId2["ProfessionalMax24PoE"] = "professionalMax24PoE";
  ProductId2["ProfessionalMax48PoE"] = "professionalMax48PoE";
  ProductId2["ProLongDistance"] = "proLongDistance";
  ProductId2["Standard16PoE"] = "standard16PoE";
  ProductId2["Standard16PoEGen1"] = "standard16PoEGen1";
  ProductId2["Standard24"] = "standard24";
  ProductId2["Standard24PE"] = "standard24PoE";
  ProductId2["Standard24PoEGen1"] = "standard24PoEGen1";
  ProductId2["Standard48"] = "standard48";
  ProductId2["Standard48PoE"] = "standard48PoE";
  ProductId2["Standard48PoEGen1"] = "standard48PoEGen1";
  ProductId2["SwitchesEnterprise"] = "switchesEnterprise";
  ProductId2["SwitchesProfessional"] = "switchesProfessional";
  ProductId2["SwitchesProfessionalMax"] = "switchesProfessionalMax";
  ProductId2["SwitchesStandard"] = "switchesStandard";
  ProductId2["SwitchesUtility"] = "switchesUtility";
  ProductId2["Theta"] = "theta";
  ProductId2["Theta360"] = "theta360";
  ProductId2["ThetaAILongDistance"] = "thetaAILongDistance";
  ProductId2["ThetaPro"] = "thetaPro";
  ProductId2["ThetaPro360"] = "thetaPro360";
  ProductId2["ThetaProWideAngle"] = "thetaProWideAngle";
  ProductId2["ThetaWideAngle"] = "thetaWideAngle";
  ProductId2["UispSwitching"] = "uispSwitching";
  ProductId2["U6Enterprise"] = "u6Enterprise";
  ProductId2["U6EnterpriseInWall"] = "u6EnterpriseInWall";
  ProductId2["U6Extender"] = "u6Extender";
  ProductId2["U6InWall"] = "u6InWall";
  ProductId2["U6Lite"] = "u6Lite";
  ProductId2["U6LR"] = "u6LR";
  ProductId2["U6Mesh"] = "u6Mesh";
  ProductId2["U6MeshPro"] = "u6MeshPro";
  ProductId2["U6Plus"] = "u6Plus";
  ProductId2["U6Pro"] = "u6Pro";
  ProductId2["U7Pro"] = "u7pro";
  ProductId2["U7ProOutdoor"] = "u7proOutdoor";
  ProductId2["U7ProWall"] = "u7proWall";
  ProductId2["UcgMax"] = "ucgMax";
  ProductId2["UcgUltra"] = "ucgUltra";
  ProductId2["UcCastLite"] = "ucCastLite";
  ProductId2["UcCastPro"] = "ucCastPro";
  ProductId2["UdmPro"] = "udmPro";
  ProductId2["UdmProMax"] = "udmProMax";
  ProductId2["UdmProSpecial"] = "udmProSpecial";
  ProductId2["Umr"] = "umr";
  ProductId2["UmrIndustrial"] = "umrIndustrial";
  ProductId2["UmrUltra"] = "umrUltra";
  ProductId2["Xg6PoEGen1"] = "xg6PoEGen1";
  ProductId2["SwissArmyKnifeUltra"] = "swissArmyKnifeUltra";
  ProductId2["DreamWall"] = "udw";
  ProductId2["DreamRouter"] = "udr";
  ProductId2["Express"] = "express";
  ProductId2["SwitchUltra"] = "switchUltra";
  ProductId2["G2StarterKitPro"] = "g2StarterKitPro";
  ProductId2["G2StarterKit"] = "g2StarterKit";
  ProductId2["ElevatorStarterKit"] = "elevatorStarterKit";
  ProductId2["AirFiber60HD"] = "airFiber60HD";
  ProductId2["AirFiber60LongRange"] = "airFiber60LongRange";
  ProductId2["AirFiber60XG"] = "airFiber60XG";
  ProductId2["AirFiber60XTremeRange"] = "airFiber60XTremeRange";
  ProductId2["AirMaxGigaBeam"] = "airMaxGigaBeam";
  ProductId2["AirMaxGigaBeamLongRange"] = "airMaxGigaBeamLongRange";
  ProductId2["AirMaxGigaBeamPlus"] = "airMaxGigaBeamPlus";
  ProductId2["WaveAp"] = "waveAp";
  ProductId2["WaveApMicro"] = "waveApMicro";
  ProductId2["WaveLongRange"] = "waveLongRange";
  ProductId2["WaveNano"] = "waveNano";
  ProductId2["WavePico"] = "wavePico";
  ProductId2["WavePro"] = "wavePro";
  ProductId2["XG"] = "xg";
  ProductId2["XGS"] = "xgs";
  ProductId2["XGSXG"] = "xgsxg";
  ProductId2["NanoG"] = "nanog";
  ProductId2["FiberLoco"] = "fiberLoco";
  ProductId2["FiberWifi6"] = "fiberWifi6";
  ProductId2["FiberWifi"] = "fiberWifi";
  ProductId2["GponOlt"] = "gponOlt";
  ProductId2["FiberInstant"] = "fiberInstant";
  ProductId2["UispRouter"] = "uispRouter";
  ProductId2["UispRouterPro"] = "uispRouterPro";
  ProductId2["UispSwitch"] = "uispSwitch";
  ProductId2["UispSwitchPlus"] = "uispSwitchPlus";
  ProductId2["UispSwitchPro"] = "uispSwitchPro";
  ProductId2["EdgeRouterX"] = "edgeRouterX";
  ProductId2["EdgeRouterXSfp"] = "edgeRouterXSfp";
  ProductId2["EdgeRouter6Poe"] = "edgeRouter6Poe";
  ProductId2["EdgeRouterInfinity"] = "edgeRouterInfinity";
  ProductId2["EdgeRouter4"] = "edgeRouter4";
  ProductId2["EdgeRouter12"] = "edgeRouter12";
  ProductId2["EdgeRouter12p"] = "edgeRouter12p";
  ProductId2["EdgeRouter10x"] = "edgeRouter10x";
  ProductId2["EdgePointS16"] = "edgePointS16";
  ProductId2["EdgePointR8"] = "edgePointR8";
  ProductId2["EdgePointR6"] = "edgePointR6";
  ProductId2["Power"] = "Power";
  ProductId2["UispPower"] = "uispPower";
  ProductId2["UispPowerPro"] = "uispPowerPro";
  ProductId2["LtuLite"] = "ltuLite";
  ProductId2["LtuPro"] = "ltuPro";
  ProductId2["LtuLongRange"] = "ltuLongRange";
  ProductId2["LtuExtremeRange"] = "ltuExtremeRange";
  ProductId2["LtuInstant"] = "ltuInstant";
  ProductId2["PrismStation5AC"] = "prismStation5AC";
  ProductId2["RocketPrism5AC"] = "rocketPrism5AC";
  ProductId2["LiteAPGPS"] = "liteAPGPS";
  ProductId2["RocketACLite"] = "rocketACLite";
  ProductId2["NanoStation5AC"] = "nanoStation5AC";
  ProductId2["NanoBeam5AC"] = "nanoBeam5AC";
  ProductId2["NanoStation5ACLoco"] = "nanoStation5ACLoco";
  ProductId2["LiteBeam5ACExtremeRange"] = "liteBeam5ACExtremeRange";
  ProductId2["LiteBeam5ACLongRange"] = "liteBeam5ACLongRange";
  ProductId2["LiteBeam5AC"] = "liteBeam5AC";
  ProductId2["LiteBeamM5"] = "liteBeamM5";
  ProductId2["PowerBeam5AC620"] = "powerBeam5AC620";
  ProductId2["PowerBeam5ACISO"] = "powerBeam5ACISO";
  ProductId2["PowerBeam5AC"] = "powerBeam5AC";
  ProductId2["NanoBeam2AC"] = "nanoBeam2AC";
  ProductId2["PowerBeam2AC400"] = "powerBeam2AC400";
  ProductId2["AirFiber2X"] = "airFiber2X";
  ProductId2["AirFiber5XHD"] = "airFiber5XHD";
  ProductId2["AirFiber5"] = "airFiber5";
  ProductId2["AirFiber11"] = "airFiber11";
  ProductId2["AirFiber24HiDensity"] = "airFiber24HiDensity";
  ProductId2["AirFiber24"] = "airFiber24";
  ProductId2["UispHorn"] = "uispHorn";
  ProductId2["UispDish"] = "uispDish";
  ProductId2["AirFiberX23dBiSlant45"] = "airFiberX23dBiSlant45";
  ProductId2["AirFiberX30dBiSlant45"] = "airFiberX30dBiSlant45";
  ProductId2["AirFiberX34dBiSlant45"] = "airFiberX34dBiSlant45";
  ProductId2["AirMAXAC30dBiRocketDish"] = "airMAXAC30dBiRocketDish";
  ProductId2["AirMAXAC34dBiRocketDish"] = "airMAXAC34dBiRocketDish";
  ProductId2["AirMAX30dBiRocketDishLW"] = "airMAX30dBiRocketDishLW";
  ProductId2["AirMAXAC31dBiRocketDish"] = "airMAXAC31dBiRocketDish";
  ProductId2["AirFiber37dBiMonsterDish"] = "airFiber37dBiMonsterDish";
  ProductId2["AirFiberX24dBiSlant45"] = "airFiberX24dBiSlant45";
  ProductId2["AirMAX24GHz13dBiOmni"] = "airMAX24GHz13dBiOmni";
  ProductId2["AirMAX24GHz10dBiOmni"] = "airMAX24GHz10dBiOmni";
  ProductId2["AirMAX5GHz13dBiOmni"] = "airMAX5GHz13dBiOmni";
  ProductId2["AirMAX5GHz10dBiOmni"] = "airMAX5GHz10dBiOmni";
  ProductId2["AirPRISM3x30HDSector"] = "airPRISM3x30HDSector";
  ProductId2["AirMAXSector24GHzTitanium"] = "airMAXSector24GHzTitanium";
  ProductId2["AirMAX900MHz13dBi120Sector"] = "airMAX900MHz13dBi120Sector";
  ProductId2["AirMAXAC5GHz21dBi60Sector"] = "airMAXAC5GHz21dBi60Sector";
  ProductId2["AirMAXAC5GHz22dBi45Sector"] = "airMAXAC5GHz22dBi45Sector";
  ProductId2["AirMAX24GHZ15dBi120Sector"] = "airMAX24GHZ15dBi120Sector";
  ProductId2["AirMAX24GHz16dBi90Sector"] = "airMAX24GHz16dBi90Sector";
  ProductId2["AirMAX5GHz19dBi120Sector"] = "airMAX5GHz19dBi120Sector";
  ProductId2["AirMAX5GHz20dBi90Sector"] = "airMAX5GHz20dBi90Sector";
  ProductId2["AirMAX5GHz16dBi120Sector"] = "airMAX5GHz16dBi120Sector";
  ProductId2["AirMAX5GHz17dBi90Sector"] = "airMAX5GHz17dBi90Sector";
  ProductId2["AirFiber"] = "airfiber";
  ProductId2["U7ProMax"] = "u7proMax";
  ProductId2["U7Outdoor"] = "u7outdoor";
  ProductId2["EdgeMaxSwitch"] = "edgeMaxSwitch";
  ProductId2["EdgeSwitch48poe"] = "edgeSwitch48poe";
  ProductId2["EdgeSwitch48poe750"] = "edgeSwitch48poe750";
  ProductId2["EdgeSwitch24poe"] = "edgeSwitch24poe";
  ProductId2["EdgeSwitch8poe"] = "edgeSwitch8poe";
  ProductId2["EdgeSwitch5xp"] = "edgeSwitch5xp";
  ProductId2["EdgeSwitch16xg"] = "edgeSwitch16xg";
  ProductId2["EdgeSwitch24poe500"] = "edgeSwitch24poe500";
  ProductId2["EdgeSwitch48lite"] = "edgeSwitch48lite";
  ProductId2["EdgeSwitch10x"] = "edgeSwitch10x";
  ProductId2["EdgeSwitch10xp"] = "edgeSwitch10xp";
  ProductId2["EdgeSwitch16poe150"] = "edgeSwitch16poe150";
  ProductId2["EdgeSwitch16xp"] = "edgeSwitch16xp";
  ProductId2["EdgeSwitch18x"] = "edgeSwitch18x";
  ProductId2["EdgeSwitch24lite"] = "edgeSwitch24lite";
  ProductId2["EdgeSwitch12f"] = "edgeSwitch12f";
  ProductId2["GateAccessStarterKit"] = "gateAccessStarterKit";
  ProductId2["UdbPro"] = "udbPro";
  ProductId2["Udb"] = "udb";
  ProductId2["GateHub"] = "gateHub";
  ProductId2["WaveApGen2"] = "waveApGen2";
  ProductId2["WaveFiberOlt"] = "waveFiberOlt";
  ProductId2["FiberOltXgs"] = "fiberOltXgs";
  ProductId2["WaveFiberOnu"] = "waveFiberOnu";
  ProductId2["WaveMLO5"] = "waveMLO5";
  ProductId2["WaveMLO6"] = "waveMLO6";
  ProductId2["EnterpriseCampusAggregation"] = "enterpriseCampusAggregation";
  ProductId2["EnterpriseCampus24"] = "enterpriseCampus24";
  ProductId2["EnterpriseCampus24PoE"] = "enterpriseCampus24PoE";
  ProductId2["EnterpriseCampus48PoE"] = "enterpriseCampus48PoE";
  ProductId2["EnterpriseCampus48"] = "enterpriseCampus48";
  ProductId2["ProfessionalHd24"] = "professionalHd24";
  ProductId2["ProfessionalHd24Poe"] = "professionalHd24Poe";
  ProductId2["SwitchesProfessionalHd"] = "switchesProfessionalHd";
  ProductId2["SwitchesProfessionalXg"] = "switchesProfessionalXg";
  ProductId2["Express7"] = "express7";
  ProductId2["UcgFiber"] = "ucgFiber";
  ProductId2["Udr7"] = "udr7";
  ProductId2["GatewayFiber"] = "gatewayFiber";
  ProductId2["U7InWall"] = "u7InWall";
  ProductId2["U7Lite"] = "u7lite";
  ProductId2["ProXg8PoE"] = "proXg8PoE";
  ProductId2["ProfessionalXg48PoE"] = "professionalXg48PoE";
  ProductId2["ProfessionalXg24PoE"] = "professionalXg24PoE";
  ProductId2["ProfessionalXg10PoE"] = "professionalXg10PoE";
  ProductId2["U7proXg"] = "u7proXg";
  ProductId2["U7proXgs"] = "u7proXgs";
  ProductId2["G6Instant"] = "g6Instant";
  ProductId2["G6Turret"] = "g6Turret";
  ProductId2["G6Bullet"] = "g6Bullet";
  ProductId2["G6ProBullet"] = "g6ProBullet";
  ProductId2["WanSwitch"] = "wanSwitch";
  ProductId2["WanSwitchRj45"] = "wanSwitchRj45";
  ProductId2["UdbProSector"] = "udbProSector";
  ProductId2["ProXgAggregation"] = "proXgAggregation";
  ProductId2["SwitchesWan"] = "switchesWan";
  ProductId2["G6PTZ"] = "g6Ptz";
  ProductId2["AiPtzIndustrial"] = "aiPtzIndustrial";
  ProductId2["AiPtzPrecision"] = "aiPtzPrecision";
  ProductId2["U7LR"] = "u7LR";
  ProductId2["G3Intercom"] = "g3Intercom";
  ProductId2["G6Dome"] = "g6Dome";
  ProductId2["G6180"] = "g6180";
  ProductId2["G6Pro360"] = "g6Pro360";
  ProductId2["Unas2"] = "unas2";
  ProductId2["Unas4"] = "unas4";
  ProductId2["UnasPro4"] = "unasPro4";
  ProductId2["UnasPro8"] = "unasPro8";
  ProductId2["UnasPro"] = "unasPro";
  ProductId2["UPSTower"] = "upsTower";
  ProductId2["UPS2U"] = "ups2u";
  ProductId2["RetrofitHub"] = "retrofitHub";
  ProductId2["RetrofitReader"] = "retrofitReader";
  return ProductId2;
})(ProductId || {});
var PropertyId = /* @__PURE__ */(PropertyId2 => {
  PropertyId2["CameraReader"] = "cameraReader";
  PropertyId2["Alignment"] = "alignment";
  PropertyId2["AntennaType"] = "antennaType";
  PropertyId2["AndroidAppMode"] = "androidAppMode";
  PropertyId2["NfcCard"] = "nfcCard";
  PropertyId2["Aux"] = "aux";
  PropertyId2["Availability"] = "availability";
  PropertyId2["BatteryFull"] = "batteryFull";
  PropertyId2["BluetoothSupport"] = "bluetoothSupport";
  PropertyId2["Builtin128GbSsd"] = "builtin128GbSsd";
  PropertyId2["Bullet"] = "bullet";
  PropertyId2["CarrierSupport"] = "carrierSupport";
  PropertyId2["CameraAudio"] = "cameraAudio";
  PropertyId2["HubDoor"] = "hubDoor";
  PropertyId2["GreetingMessages"] = "greetingMessages";
  PropertyId2["IdentityAppUnlock"] = "identityAppUnlock";
  PropertyId2["PoePlus2"] = "poePlus2";
  PropertyId2["Cellular"] = "cellular";
  PropertyId2["CameraResolution"] = "cameraResolution";
  PropertyId2["ClientDevices"] = "clientDevices";
  PropertyId2["Compact"] = "compact";
  PropertyId2["ConnectedDevices"] = "connectedDevices";
  PropertyId2["Connectivity"] = "connectivity";
  PropertyId2["Coverage"] = "coverage";
  PropertyId2["ChargingConnector"] = "chargingConnector";
  PropertyId2["DataPlan"] = "dataPlan";
  PropertyId2["DataProtection"] = "dataProtection";
  PropertyId2["Deployment"] = "deployment";
  PropertyId2["Display"] = "display";
  PropertyId2["Dome"] = "dome";
  PropertyId2["DoorAccessSupport"] = "doorAccessSupport";
  PropertyId2["PinAccess"] = "pinAccess";
  PropertyId2["PaymentTerminalSupport"] = "paymentTerminalSupport";
  PropertyId2["DownlinkSpeed"] = "downlinkSpeed";
  PropertyId2["DriveHotSwap"] = "driveHotSwap";
  PropertyId2["DyingGaspSupport"] = "dyingGaspSupport";
  PropertyId2["DigitalSignageSupport"] = "digitalSignageSupport";
  PropertyId2["EnhancedDetections"] = "enhancedDetections";
  PropertyId2["ErgonomicHandsetWithMuteButton"] = "ergonomicHandsetWithMuteButton";
  PropertyId2["Exit"] = "exit";
  PropertyId2["ExternalAntennaSupport"] = "externalAntennaSupport";
  PropertyId2["FieldOfView"] = "fieldOfView";
  PropertyId2["FormFactor"] = "formFactor";
  PropertyId2["Frequency"] = "frequency";
  PropertyId2["Hand"] = "hand";
  PropertyId2["IdsIpsThroughput"] = "idsIpsThroughput";
  PropertyId2["IntegratedPoeSwitch"] = "integratedPoeSwitch";
  PropertyId2["IntegratedSwitch"] = "integratedSwitch";
  PropertyId2["InteriorDesign"] = "interiorDesign";
  PropertyId2["ImageSensor"] = "imageSensor";
  PropertyId2["LanPorts"] = "lanPorts";
  PropertyId2["LedDisplay"] = "ledDisplay";
  PropertyId2["LicensePlateRecognition"] = "licensePlateRecognition";
  PropertyId2["ManagedCameras"] = "managedCameras";
  PropertyId2["MaximumRange"] = "maximumRange";
  PropertyId2["MaxChargingOutput"] = "maxChargingOutput";
  PropertyId2["Mounting"] = "mounting";
  PropertyId2["NetworkingInterface"] = "networkingInterface";
  PropertyId2["LicenseFreeNextAiSSLInspection"] = "licenseFreeNextAiSSLInspection";
  PropertyId2["NightVision"] = "nightVision";
  PropertyId2["NvrHdd35Bay"] = "nvrHdd35Bay";
  PropertyId2["NvrPowerBackup"] = "nvrPowerBackup";
  PropertyId2["NvrStacking"] = "nvrStacking";
  PropertyId2["OpticalZoom"] = "opticalZoom";
  PropertyId2["OutdoorReady"] = "outdoorReady";
  PropertyId2["PoeAvailability"] = "poeAvailability";
  PropertyId2["PoeOutput"] = "poeOutput";
  PropertyId2["PoePlus"] = "poePlus";
  PropertyId2["PortCount"] = "portCount";
  PropertyId2["PowerMethod"] = "powerMethod";
  PropertyId2["PowerMethodPoe"] = "powerMethodPoe";
  PropertyId2["PowerRedundancy"] = "powerRedundancy";
  PropertyId2["ProAvSupport"] = "proAvSupport";
  PropertyId2["Ptz"] = "ptz";
  PropertyId2["Radio6Ghz"] = "radio6Ghz";
  PropertyId2["Radios"] = "radios";
  PropertyId2["Screen"] = "screen";
  PropertyId2["SimCard"] = "simCard";
  PropertyId2["SmartDetections"] = "smartDetections";
  PropertyId2["Sound"] = "sound";
  PropertyId2["Speakerphone"] = "speakerphone";
  PropertyId2["Storage"] = "storage";
  PropertyId2["StorageCapacity"] = "storageCapacity";
  PropertyId2["StationSecurityModes"] = "stationSecurityModes";
  PropertyId2["SubscriptionLockedAndUnlockedModels"] = "subscriptionLockedAndUnlockedModels";
  PropertyId2["SwitchTechnology"] = "switchTechnology";
  PropertyId2["GpsLocationTracking"] = "gpsLocationTracking";
  PropertyId2["Throughput"] = "throughput";
  PropertyId2["Touchscreen13inch"] = "touchscreen13inch";
  PropertyId2["UnifiAppSuite"] = "unifiAppSuite";
  PropertyId2["UnifiDevices"] = "unifiDevices";
  PropertyId2["UnifiPowerBackup"] = "unifiPowerBackup";
  PropertyId2["Unlock"] = "unlock";
  PropertyId2["Uplink"] = "uplink";
  PropertyId2["UplinkSpeed"] = "uplinkSpeed";
  PropertyId2["TamperResistance"] = "tamperResistance";
  PropertyId2["WanPorts"] = "wanPorts";
  PropertyId2["Waterproof"] = "waterproof";
  PropertyId2["WifiIntegrated"] = "wifiIntegrated";
  PropertyId2["WifiPowerMethod"] = "wifiPowerMethod";
  PropertyId2["Wifi6Technology"] = "wifi6Technology";
  PropertyId2["WifiTechnology"] = "wifiTechnology";
  PropertyId2["Etherlighting"] = "etherlighting";
  PropertyId2["IntegratedWifi6"] = "integratedWiFi6";
  PropertyId2["AvailablePorts"] = "availablePorts";
  PropertyId2["Ports"] = "ports";
  PropertyId2["IncludedHub"] = "includedHub";
  PropertyId2["IncludedReaders"] = "includedReaders";
  PropertyId2["IncludedAccessories"] = "includedAccessories";
  PropertyId2["Installation"] = "installation";
  PropertyId2["OutputRelays"] = "outputRelays";
  PropertyId2["InputTerminals"] = "inputTerminals";
  PropertyId2["PoePorts"] = "poePorts";
  PropertyId2["AccessPowerMethod"] = "accessPowerMethod";
  PropertyId2["Intercom"] = "intercom";
  PropertyId2["MobileTap"] = "mobileTap";
  PropertyId2["MobileAppAccess"] = "mobileAppAccess";
  PropertyId2["ReaderPowerMethod"] = "readerPowerMethod";
  PropertyId2["BackupRadio"] = "backupRadio";
  PropertyId2["ClientCapacity"] = "clientCapacity";
  PropertyId2["Dimensions"] = "dimensions";
  PropertyId2["IntegratedBluetooth"] = "integratedBluetooth";
  PropertyId2["IntegratedGps"] = "integratedGps";
  PropertyId2["MaximumLinkRange"] = "maximumLinkRange";
  PropertyId2["MaxThroughput"] = "maxThroughput";
  PropertyId2["MaxTotalThroughput"] = "maxTotalThroughput";
  PropertyId2["PrecisionAlignmentMount"] = "precisionAlignmentMount";
  PropertyId2["UispCoverage"] = "uispCoverage";
  PropertyId2["WaveTechnology"] = "waveTechnology";
  PropertyId2["Weight"] = "weight";
  PropertyId2["MaxLinkRange"] = "maxLinkRange";
  PropertyId2["Bridge"] = "bridge";
  PropertyId2["PoeSwitch"] = "poeSwitch";
  PropertyId2["Technology"] = "technology";
  PropertyId2["NatThroughput"] = "natThroughput";
  PropertyId2["TrafficShaping"] = "trafficShaping";
  PropertyId2["Firewall"] = "firewall";
  PropertyId2["Redundancy"] = "redundancy";
  PropertyId2["MountType"] = "mountType";
  PropertyId2["UispBox"] = "uispBox";
  PropertyId2["LayerTwoFunctionality"] = "layerTwoFunctionality";
  PropertyId2["InternalSwitch"] = "internalSwitch";
  PropertyId2["PoeInput"] = "poeInput";
  PropertyId2["DcPowerOutput"] = "dcPowerOutput";
  PropertyId2["PowerTransportOutput"] = "powerTransportOutput";
  PropertyId2["UpsFunctionality"] = "upsFunctionality";
  PropertyId2["InternalBatterySupport"] = "internalBatterySupport";
  PropertyId2["ExternalBatterySupport"] = "externalBatterySupport";
  PropertyId2["PowerLoadBalancing"] = "powerLoadBalancing";
  PropertyId2["HealthMonitoring"] = "healthMonitoring";
  PropertyId2["SmsLte"] = "smsLte";
  PropertyId2["Touchscreen"] = "touchscreen";
  PropertyId2["WindLoading"] = "windLoading";
  PropertyId2["Swivel"] = "swivel";
  PropertyId2["SwivelPowerMethod"] = "swivelPowerMethod";
  PropertyId2["SwivelSpectralEfficiency"] = "swivelSpectralEfficiency";
  PropertyId2["SwivelPackets"] = "swivelPackets";
  PropertyId2["SwivelLatency"] = "swivelLatency";
  PropertyId2["Denoise"] = "denoise";
  PropertyId2["Focus"] = "focus";
  PropertyId2["DedicatedWiFi"] = "dedicatedWiFi";
  PropertyId2["LinkRange"] = "linkRange";
  PropertyId2["NetworkInterface"] = "networkInterface";
  PropertyId2["SpectralEfficiency"] = "spectralEfficiency";
  PropertyId2["ElevationBeamwidth"] = "elevationBeamwidth";
  PropertyId2["RadiusCoverage"] = "radiusCoverage";
  PropertyId2["AntennaGain"] = "antennaGain";
  PropertyId2["Customization"] = "customization";
  PropertyId2["DedicatedSpectralScanningEngine"] = "dedicatedSpectralScanningEngine";
  PropertyId2["WiFi"] = "wifi";
  PropertyId2["WiFiMounting"] = "wifiMounting";
  PropertyId2["DigitalSignageMode"] = "digitalSignageMode";
  PropertyId2["VideoContentSupport"] = "videoContentSupport";
  PropertyId2["WebMode"] = "webMode";
  PropertyId2["YoutubeMode"] = "youtubeMode";
  PropertyId2["HdmiCec"] = "hdmiCec";
  PropertyId2["UsbCPeripheralSupport"] = "usbCPeripheralSupport";
  PropertyId2["VantagePoint"] = "vantagePoint";
  PropertyId2["LinkPuncturing"] = "linkPuncturing";
  PropertyId2["RfFilteringTechnology"] = "rfFilteringTechnology";
  PropertyId2["Weatherproofing"] = "weatherproofing";
  PropertyId2["RedundantRj45Port"] = "redundantRj45Port";
  PropertyId2["FipsCompliance"] = "fipsCompliance";
  PropertyId2["ExtendedRangeMode6Ghz"] = "extendedRangeMode6Ghz";
  PropertyId2["Directory"] = "directory";
  PropertyId2["TwoWayIntercom"] = "twoWayIntercom";
  PropertyId2["WirelessHeadsetSupport"] = "wirelessHeadsetSupport";
  PropertyId2["WirelessHandsetSupport"] = "wirelessHandsetSupport";
  PropertyId2["PbxSupport"] = "pbxSupport";
  PropertyId2["CrestonNaxNvxCertified"] = "crestonNaxNvxCertified";
  PropertyId2["HighPerformanceSpeaker"] = "highPerformanceSpeaker";
  PropertyId2["PhoneConnectivity"] = "phoneConnectivity";
  PropertyId2["PhoneMounting"] = "phoneMounting";
  PropertyId2["IntegratedWiFi"] = "integratedWiFi";
  PropertyId2["AiRecognition"] = "aiRecognition";
  PropertyId2["PortLayout"] = "portLayout";
  PropertyId2["SwitchingCapacity"] = "switchingCapacity";
  PropertyId2["TotalNonBlockingThroughput"] = "totalNonBlockingThroughput";
  PropertyId2["ForwardingRate"] = "forwardingRate";
  PropertyId2["MgmtPort"] = "mgmtPort";
  PropertyId2["TouchPassSupport"] = "touchPassSupport";
  PropertyId2["AppleTouchPassAccess"] = "appleTouchPassAccess";
  PropertyId2["BuiltInFloodlight"] = "builtInFloodlight";
  PropertyId2["ManagedUnifiDevices"] = "managedUnifiDevices";
  PropertyId2["SimultaneousUsersConnected"] = "simultaneousUsersConnected";
  PropertyId2["MaxWanPortCount"] = "maxWanPortCount";
  PropertyId2["GeneralRedundancy"] = "generalRedundancy";
  PropertyId2["FaceRecognition"] = "faceRecognition";
  PropertyId2["McLagSupport"] = "mcLagSupport";
  PropertyId2["UnasPowerMethod"] = "unasPowerMethod";
  PropertyId2["HotSwappableBattery"] = "hotSwappableBattery";
  PropertyId2["FieldReplaceableBattery"] = "fieldReplaceableBattery";
  PropertyId2["NUTSupport"] = "nutSupport";
  PropertyId2["Capacity"] = "capacity";
  PropertyId2["Power"] = "power";
  return PropertyId2;
})(PropertyId || {});
var ProductGroupId = /* @__PURE__ */(ProductGroupId2 => {
  ProductGroupId2["Bullet"] = "bullet";
  ProductGroupId2["Compact"] = "compact";
  ProductGroupId2["DomeTurret"] = "domeTurret";
  ProductGroupId2["InteriorDesign"] = "interiorDesign";
  ProductGroupId2["PTZ"] = "ptz";
  ProductGroupId2["TwoPointFiveTenGigabitEthernet"] = "twoPointFiveTenGigabitEthernet";
  ProductGroupId2["Aggregation"] = "aggregation";
  ProductGroupId2["SwitchingCompact"] = "switchingCompact";
  ProductGroupId2["GigabitEthernet"] = "gigabitEthernet";
  ProductGroupId2["Enterprise"] = "enterprise";
  ProductGroupId2["ProfessionalMax"] = "professionalMax";
  ProductGroupId2["Professional"] = "professional";
  ProductGroupId2["ProductListDomeTurret"] = "productListDomeTurret";
  ProductGroupId2["ProductListCompact"] = "productListCompact";
  ProductGroupId2["ProductListInteriorDesign"] = "productListInteriorDesign";
  ProductGroupId2["ProductListPTZ"] = "productListPTZ";
  ProductGroupId2["WiFiFlagShip"] = "wifiFlagship";
  ProductGroupId2["WiFiWall"] = "wifiWall";
  ProductGroupId2["WiFiOutdoor"] = "wifiOutdoor";
  ProductGroupId2["WiFiMegaCapacity"] = "wifiMegaCapacity";
  ProductGroupId2["WiFiBuildingBridge"] = "wifiBuildingBridge";
  ProductGroupId2["WiFiE7"] = "wifiE7";
  return ProductGroupId2;
})(ProductGroupId || {});
var ProductListGroupId = /* @__PURE__ */(ProductListGroupId2 => {
  ProductListGroupId2["Enterprise"] = "enterprise";
  ProductListGroupId2["Compact"] = "compact";
  ProductListGroupId2["WiFiIntegrated"] = "wifiIntegrated";
  ProductListGroupId2["LargeScale"] = "largeScale";
  ProductListGroupId2["Standard"] = "standard";
  ProductListGroupId2["Utility"] = "utility";
  ProductListGroupId2["Bullet"] = "bullet";
  ProductListGroupId2["DomeTurret"] = "domeTurret";
  ProductListGroupId2["InteriorDesign"] = "interiorDesign";
  ProductListGroupId2["Aggregation"] = "aggregation";
  ProductListGroupId2["Professional"] = "professional";
  ProductListGroupId2["ProfessionalMax"] = "professionalMax";
  ProductListGroupId2["PTZ"] = "ptz";
  ProductListGroupId2["BuildingBridge"] = "buildingBridge";
  ProductListGroupId2["WiFiE7"] = "wifiE7";
  ProductListGroupId2["Flagship"] = "flagship";
  ProductListGroupId2["MegaCapacity"] = "megaCapacity";
  ProductListGroupId2["Outdoor"] = "outdoor";
  ProductListGroupId2["Wall"] = "wall";
  ProductListGroupId2["DeviceBridge"] = "deviceBridge";
  ProductListGroupId2["ProductListSwitchingEnterprise"] = "productListSwitchingEnterprise";
  ProductListGroupId2["ProductListSwitchingProfessional"] = "productListSwitchingProfessional";
  ProductListGroupId2["ProductListSwitchingValue"] = "productListSwitchingValue";
  ProductListGroupId2["ProductListSwitchingCompact"] = "productListSwitchingCompact";
  ProductListGroupId2["StarterKits"] = "starterKits";
  ProductListGroupId2["ControlHubs"] = "controlHubs";
  ProductListGroupId2["ReadersAndIntercom"] = "readersAndIntercom";
  return ProductListGroupId2;
})(ProductListGroupId || {});
var MutatedPropertyType = /* @__PURE__ */(MutatedPropertyType2 => {
  MutatedPropertyType2["Translation"] = "translation";
  MutatedPropertyType2["String"] = "string";
  MutatedPropertyType2["Boolean"] = "boolean";
  MutatedPropertyType2["Custom"] = "custom";
  return MutatedPropertyType2;
})(MutatedPropertyType || {});
export { MutatedPropertyType, ProductGroupId, ProductId, ProductListGroupId, PropertyId };
//# sourceMappingURL=types.mjs.map
